import React, { useState, useEffect } from 'react';
import { db, storage, auth } from '../../../Firebase/Firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';
import './perfilNegocio.css';
import { motion } from "framer-motion"; // asegúrate de instalarlo: npm install framer-motion
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {
  FaInstagram, FaFacebook, FaTwitter, FaLinkedin, FaTiktok,
  FaYoutube, FaWhatsapp, FaTelegramPlane, FaGlobe
} from 'react-icons/fa';
const BusinessProfileForm = () => {
  const [servicios, setServicios] = useState([]);
  const [uid, setUid] = useState(null);
  const [fase, setFase] = useState(0);
  const [redesAgregadas, setRedesAgregadas] = useState([]);

  const cargarServicios = async (uid) => {
    const q = query(collection(db, 'servicios'), where('uid', '==', uid));
    const snapshot = await getDocs(q);
    const datos = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setServicios(datos);
  };


  const redesDisponibles = [
    { key: 'instagram', label: 'Instagram', placeholder: '@usuario' },
    { key: 'facebook', label: 'Facebook', placeholder: 'https://facebook.com/usuario' },
    { key: 'twitter', label: 'Twitter / X', placeholder: '@usuario' },
    { key: 'linkedin', label: 'LinkedIn', placeholder: 'https://linkedin.com/in/usuario' },
    { key: 'tiktok', label: 'TikTok', placeholder: '@usuario' },
    { key: 'youtube', label: 'YouTube', placeholder: 'https://youtube.com/@usuario' },
    { key: 'whatsapp', label: 'WhatsApp', placeholder: '+593999999999' },
    { key: 'telegram', label: 'Telegram', placeholder: '@usuario' },
    { key: 'web', label: 'Página Web', placeholder: 'https://tusitio.com' },
  ];

  useEffect(() => {
    if (uid) cargarServicios(uid);
  }, [uid]);
  const [usuarioData, setUsuarioData] = useState({
    email: '',
    fechaNacimiento: '',
  });
  const [perfil, setPerfil] = useState({
    tipo: 'persona',
    nombre: '',
    descripcion: '',
    telefono: '',
    foto: null,
    fotoURL: '',
  });
  const [redes, setRedes] = useState({
    instagram: '',
    facebook: '',
    twitter: '',
    linkedin: '',
    tiktok: '',
    youtube: '',
    whatsapp: '',
    telegram: '',
    web: '',
  });

  const [uploading, setUploading] = useState(false);
  const [mensaje, setMensaje] = useState('');

  // Detectar usuario logueado y cargar datos
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUid(user.uid);
        const userRef = doc(db, 'usuarios', user.uid);
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          const perfil = data.perfilNegocio || {};
          setPerfil({
            tipo: perfil.tipo || 'persona',
            nombre: perfil.nombre || data.name || '',
            descripcion: perfil.descripcion || '',
            telefono: perfil.telefono || '',
            foto: null,
            fotoURL: perfil.fotoURL || '',

          });
          setUsuarioData({
            email: data.email || '',
            fechaNacimiento: data.fechaNacimiento || '',
          });
          setRedes({
            instagram: data.redes?.instagram || '',
            facebook: data.redes?.facebook || '',
            twitter: data.redes?.twitter || '',
            linkedin: data.redes?.linkedin || '',
            tiktok: data.redes?.tiktok || '',
            youtube: data.redes?.youtube || '',
            whatsapp: data.redes?.whatsapp || '',
            telegram: data.redes?.telegram || '',
            web: data.redes?.web || '',
          });
          setFase(data.fase || 0);
          if (data.redes) {
            setRedesAgregadas(Object.keys(data.redes));
          }

        }
      }
    });

    return () => unsubscribe();
  }, []);


  const handleChange = (e) => {
    const { name, files, value } = e.target;
    if (name === 'foto') {
      const file = files[0];
      if (file) {
        const fotoURL = URL.createObjectURL(file);
        setPerfil(prev => {
          // Si ya hay una URL, revocarla para liberar memoria
          if (prev.fotoURL) {
            URL.revokeObjectURL(prev.fotoURL);
          }
          return { ...prev, foto: file, fotoURL };
        });
      }
    } else {
      setPerfil(prev => ({ ...prev, [name]: value }));
    }
  };

  // Limpiar URL al desmontar componente
  useEffect(() => {
    return () => {
      if (perfil.fotoURL) {
        URL.revokeObjectURL(perfil.fotoURL);
      }
    };
  }, [perfil.fotoURL]);

  const [asistenteActivo, setAsistenteActivo] = useState(false);

  // Detectamos si es necesario mostrar el asistente
  useEffect(() => {
    if (perfil.nombre === '' && perfil.descripcion === '' && perfil.telefono === '') {
      setAsistenteActivo(true); // primera vez
    }
  }, [perfil]);

  const handleBack = async (e) => {
    const userRef = doc(db, 'usuarios', uid);
    setFase(fase + 1);
    await updateDoc(userRef, {

      fase: fase - 1,

    });
    setFase(fase - 1);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!uid) return;

    setUploading(true);
    setMensaje('');

    try {
      let fotoURL = perfil.fotoURL;
      // Paso previo a guardar
      const redesLimpias = Object.fromEntries(
        Object.entries(redes || {}).filter(
          ([_, valor]) => valor && valor.trim() !== ''
        )
      );

      if (perfil.foto) {
        const storageRef = ref(storage, `fotosPerfiles/${uuidv4()}_${perfil.foto.name}`);
        await uploadBytes(storageRef, perfil.foto);
        fotoURL = await getDownloadURL(storageRef);
      }

      const userRef = doc(db, 'usuarios', uid);
      setFase(fase + 1);
      await updateDoc(userRef, {
        perfilNegocio: {
          tipo: perfil.tipo,
          nombre: perfil.nombre,
          descripcion: perfil.descripcion,
          telefono: perfil.telefono,
          fotoURL,
          fechaActualizacion: new Date(),

        },
        redes: redesLimpias || {},
        fechaNacimiento: usuarioData.fechaNacimiento,
        fase: fase + 1,

      });

      setMensaje('¡Perfil actualizado exitosamente!');
    } catch (error) {
      console.error('Error al actualizar el perfil:', error);
      setMensaje('Ocurrió un error al guardar los datos.');
    }

    setUploading(false);
  };


  // Si ya pasamos la fase 2, mostramos el formulario normal:
  if (fase === 0) {
    return (
      <div className="fase-bienvenida pantalla-completa">
        <motion.div
          className="contenedor-bienvenida"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="saludo-titulo">¡Hola {perfil.nombre || 'Amigo'}! 👋</h1>

          <p className="texto-bienvenida">
            Bienvenido a <strong>Ofi.Work Servicios</strong>, el lugar donde tus ideas se convierten en soluciones.
            Si deseas, puedes actualizar tu nombre para mostrarlo en tu perfil.
          </p>

          <input
            type="text"
            id="nombre"
            name="nombre"
            placeholder="Tu nombre"
            value={perfil.nombre}
            onChange={handleChange}
            required
            className="input-nombre"
            autoComplete="off"
          />

<br/><br/>
          <h2 className="mensaje-pequena mt-4" htmlFor="tipo">
            ¿Cómo deseas presentarte en la plataforma?
          </h2>
          <h2 className="mensaje-pequena">
            Elige si estás creando este perfil como una <strong>persona individual</strong> o como una <strong>marca o emprendimiento</strong>.
          </h2>

          <div className="radio-button-container">
            <label className={`radio-button ${perfil.tipo === 'persona' ? 'selected' : ''}`}>
              <input
                type="radio"
                name="tipo"
                value="persona"
                checked={perfil.tipo === 'persona'}
                onChange={handleChange}
              />
              🙋‍♂️ Persona
            </label>

            <label className={`radio-button ${perfil.tipo === 'marca' ? 'selected' : ''}`}>
              <input
                type="radio"
                name="tipo"
                value="marca"
                checked={perfil.tipo === 'marca'}
                onChange={handleChange}
              />
              🏷️ Marca / Emprendimiento
            </label>
          </div>


          <button onClick={handleSubmit} className="boton-proximo">Continuar</button>

        </motion.div>

      </div>
    );
  }

  if (fase === 1) {
    return (
      <div className="pantalla-completa">
        <motion.div
          className="contenedor-bienvenida"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="saludo-titulo">📸 ¡Ya casi terminamos, {perfil.nombre}!</h1>
          <p className="texto-bienvenida">
            Sube una foto de perfil o logo que te represente. También necesitamos tu fecha de nacimiento y una breve descripción.
          </p>

          {/* Subida de foto */}
          <label className="label-forms">Foto de perfil o Logo</label>
          <input
            type="file"
            name="foto"
            accept="image/*"
            onChange={handleChange}
            className="w-full p-2 border rounded mb-4"
          />
          {perfil.fotoURL && (
            <img
              src={perfil.fotoURL}
              alt="Foto de perfil"
              className="img-perfil"
            />
          )}

          {/* Fecha de nacimiento */}
          <label className="label-campo">Fecha de nacimiento</label>
          <input
            type="date"
            name="fechaNacimiento"
            value={usuarioData.fechaNacimiento || ''}
            onChange={handleChange}
            className="input-nombre"
          />

          {/* Descripción */}
          <label className="label-campo mt-3">Descripción o biografía</label>
          <textarea
            name="descripcion"
            placeholder="¿Qué te gustaría que sepamos sobre ti?"
            value={perfil.descripcion || ''}
            onChange={handleChange}
            className="textarea-descripcion"
            rows={4}
          />

          <button onClick={handleBack} className="boton-regresar">Regresar</button>
          <button onClick={handleSubmit} className="boton-proximo ">Siguiente</button>
        </motion.div>
      </div>
    );

  }

  if (fase === 2) {
    return (
      <div className="pantalla-completa">
        <motion.div
          className="contenedor-bienvenida"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="saludo-titulo">¡Genial, {perfil.nombre}!</h1>
          <p className="texto-bienvenida">
            Cuéntanos cómo podemos contactarte. Ingresa tu número con el código de país.
          </p>

          <PhoneInput

            country={'ec'}
            value={perfil.telefono}
            onChange={(telefono) =>
              setPerfil(prev => ({ ...prev, telefono }))
            }
            inputClass="input-tel"
            containerStyle={{ marginBottom: '1.5rem' }}
          />
          {/* Redes Sociales dinámicas */}
          <div className="mt-4">
            <label className="label-campo">Agrega tus redes sociales</label>

            {/* Dropdown para seleccionar red */}
            <div className="flex gap-2 mb-3">
              <select
                value=""
                onChange={(e) => {
                  const selected = e.target.value;
                  if (!redesAgregadas.includes(selected)) {
                    setRedesAgregadas((prev) => [...prev, selected]);
                  }
                }}
                className="input-nombre"
              >
                <option value="">Selecciona una red</option>
                {redesDisponibles
                  .filter((red) => !redesAgregadas.includes(red.key))
                  .map((red) => (
                    <option key={red.key} value={red.key}>
                      {red.label}
                    </option>
                  ))}
              </select>
            </div>

            {/* Campos de redes seleccionadas */}
            {redesAgregadas.map((key) => {
              const red = redesDisponibles.find((r) => r.key === key);
              return (
                <div key={key} className="campo-red">
                  <div className="input-con-icono">
                    {key === 'instagram' && <FaInstagram />}
                    {key === 'facebook' && <FaFacebook />}
                    {key === 'twitter' && <FaTwitter />}
                    {key === 'linkedin' && <FaLinkedin />}
                    {key === 'tiktok' && <FaTiktok />}
                    {key === 'youtube' && <FaYoutube />}
                    {key === 'whatsapp' && <FaWhatsapp />}
                    {key === 'telegram' && <FaTelegramPlane />}
                    {key === 'web' && <FaGlobe />}
                    <input
                      type="text"
                      placeholder={red.placeholder}
                      value={redes?.[key] || ''}
                      onChange={(e) =>
                        setRedes((prev) => ({
                          ...prev,
                          [key]: e.target.value,
                        }))
                      }
                      className="input-red-social"
                    />
                    <button
                      onClick={() =>
                        setRedesAgregadas((prev) => prev.filter((r) => r !== key))
                      }
                      className="btn-eliminar-red"
                      type="button"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
          <button onClick={handleBack} className="boton-regresar">Regresar</button>

          <button onClick={handleSubmit} className="boton-proximo">Siguiente</button>
        </motion.div>
      </div>
    );


  }
  if (fase >= 3) {
    return (
      <div className="pantalla-completa felicitacion-container">
        <motion.div
          className="contenedor-bienvenida"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="saludo-titulo">🎉 ¡Felicidades, {perfil.nombre}!</h1>
          <p className="mensaje">
            Has completado tu perfil exitosamente.
          </p>
          <p className="texto-bienvenida">
            Ahora puedes comenzar a agregar tus servicios para que tus clientes te encuentren.
          </p>

          <div className="botones-accion">
            <button
              className="boton-proximo"
              onClick={ () => {
                window.location.href = '/crear-servicio'; // Reemplaza con la ruta real
              }}
            >
              Poner mi servicio
            </button>

            <button
              className="boton-secundario"
              onClick={() => window.location.href = `/perfil/${uid}`}
            >
              Ver perfil
            </button>
            <button onClick={handleBack} className="boton-regresar">Regresar</button>

            <button
              className="boton-secundario"
              onClick={() => window.location.href = `/perfil/${uid}`}
            >
              Agregar mi servicio más tarde
            </button>
          </div>
        </motion.div>
      </div>
    );
  }
};
export default BusinessProfileForm;
